// extracted by mini-css-extract-plugin
export default {"navbar":"bottomNavBar_navbar__gBwVv","searchBtn":"bottomNavBar_searchBtn__X-OOf","loginBtn":"bottomNavBar_loginBtn__PzVtp","iconLabel":"bottomNavBar_iconLabel__n14lz"};